<template>
  <div id="prop-member" class="prop-member-cont" v-if="track.visitorEmailId === '0'">
    <div class="prop-member" :class="{skeleton: loading}">
      <div class="loader" v-if="loading"/>
      <div class="banner">
        <p v-if="price.discount_price && price.available_discount > 0" class="text">
          Save an extra {{price.available_discount | money}} by becoming a member.
        </p>
        <p v-else class="text">
          Become a <b>member for free</b> to access <b>exclusive deals</b>
        </p>
        <button @click="clickBanner" aria-label="Become member">
          Join now
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    price: Object,
    loading: Boolean,
    track: Object
  },
  filters: {
    money: function(val) {
      return st.money(val)
    }
  },
  methods: {
    clickBanner() {
      this.$emit('clickBanner', null, null, 'desktop_panel')
    }
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-member-cont {
  margin: 1.25rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #D9D9D9;

  @media #{$desktop} {
    margin: 1.25rem 0;
  }

  .prop-member {
    .banner {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-between;
      background: #EBE7F2;
      border-radius: .25rem;
      padding: .75rem 1.25rem;
      border: 1px solid $col_purple;
      box-sizing: border-box;
      width: 100%;
      height: 100%;

      @media #{$desktop} {
        flex-direction: row;
        align-items: center;
      }

      p {
        color: $col_purple;
        font-size: .875rem;
        @media #{$desktop} {
          font-size: 1rem;
        }
      }

      button {
        cursor: pointer;
        font-weight: 600;
        color: $col_white;
        font-size: 0.875rem;
        line-height: 1.125rem;
        border-radius: .25rem;
        padding: .5rem 1.5rem;
        background-color: $col_purple;
        white-space: nowrap;

        &:hover, &:active, &:focus {
          background-color: lighten($col_purple, 10%);
        }
      }
    }

    &.skeleton {
      border-radius: .25rem;
      height: 4.125rem;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .banner {
        display: none;
      }

      @media #{$desktop} {
        height: 3.75rem;
      }
    }

    .text {
      opacity: 1;
      display: block;
      padding-bottom: .625rem;

      @media #{$desktop} {
        padding-bottom: 0;
        padding-right: .625rem;
      }
    }

    @media #{$desktop} {
      &.skeleton {
        height: 3.75rem;
      }
    }
  }

  .loader {
    appearance: none;
    margin-right: 0;
    margin-bottom: 0;
    min-height: 2rem;
    min-width: 11.25rem;
    width: auto;
    height: auto;
    overflow: hidden;
    color: transparent !important;
    border: none !important;
    fill: transparent;
    text-shadow: none;
    box-sizing: border-box;
    box-shadow: none;
    will-change: background;
    background-color: #ccc;
    background-image: linear-gradient(90deg, #ddd 0, #e8e8e8 2.5rem, #ddd 5rem);
    background-size: 18.75rem;
    border-radius: 0.125rem;
    animation: shine-lines 1.6s infinite linear;
  }
}

</style>